import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { LOCAL_STORAGE_KEYS } from '@/constants';
import {
  getDeviceValues,
  isValidDevice,
  resolveDeviceValue,
  updateNavigation
} from '@/modules/perseo-billing/hooks/use-device-params/utils';

const useDeviceParam = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cartSource = useAppSelector((state) => state?.cart?.data?.source) ?? '';
  const processedRef = useRef(false);

  useEffect(() => {
    if (!cartSource || !location || !navigate) return;
    if (processedRef.current) return;

    const deviceValues = getDeviceValues(location, cartSource);
    const deviceValue = resolveDeviceValue(deviceValues);

    if (isValidDevice(deviceValue)) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.DEVICE, deviceValue);
    }

    processedRef.current = true;
    updateNavigation(deviceValue, navigate);
  }, [cartSource, location, navigate]);
};

export default useDeviceParam;
